import React, {useCallback, useImperativeHandle, useRef} from 'react';
import ChatMessage from "../../../../../../components/chat/chat-message.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import html2canvas from "html2canvas";
import ViolenceType from "../../../citizen/utils/violence-type.js";
import ProtectionTypes from "../../../citizen/utils/protection-type.js";
import prepareAddress from "../utils/prepareAddress.js";
import {FaUser} from "react-icons/fa";
import "../../../css/citizen.css"
import PrintTemplate from "../../../../../../components/reports/print-reports/print-template.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";

const SosPrint = ({event, citizen, location, chat, printRef, mapRef, target, headerTemplateSelected, isApi, showRoute}) => {
    const printComponentRef = useRef(null);

    const print = useCallback(() => {
        document.querySelectorAll(".print-none").forEach(element => element.classList.add("d-none"));
        document.querySelector(".gm-fullscreen-control").classList.add("d-none");
        document.querySelectorAll(".gmnoprint").forEach(element => element.classList.add("d-none"));
        document.querySelectorAll(".gm-style-iw-tc").forEach(element => element.classList.add("d-none"));
        document.querySelectorAll(".gm-style-iw").forEach(element => element.classList.add("d-none"));

        window.onafterprint = function () {
            document.querySelectorAll(".print-none").forEach(element => element.classList.remove("d-none"));
            document.querySelector(".gm-fullscreen-control").classList.remove("d-none");
            document.querySelectorAll(".gmnoprint").forEach(element => element.classList.remove("d-none"));
            document.querySelectorAll(".gm-style-iw-tc").forEach(element => element.classList.remove("d-none"));
            document.querySelectorAll(".gm-style-iw").forEach(element => element.classList.remove("d-none"));
        };

        html2canvas(mapRef.current, {
            allowTaint: true,
            useCORS: false,
        }).then(canvas => {
            document.getElementById('mapSnapshot').appendChild(canvas).classList.add('mapCanvas');

            printComponentRef.current?.print();

            setTimeout(() => {
                const mapSnap = document.getElementById('mapSnapshot');
                mapSnap.removeChild(mapSnap.firstChild);
            }, 200)
        });
    }, [])

    useImperativeHandle(printRef, () => ({ print }));

    if (!event) return;

    return (
        <PrintTemplate title={"Histórico do SOS"} entity={headerTemplateSelected} ref={printComponentRef} printClassName={"resume-content hidden print:block"}>
            <div className={"space-y-4"}>
                <article className={"space-y-4"}>
                    <h2 className={"resume-title"}>
                        Dados do SOS
                    </h2>

                    <section className={"grid grid-cols-4 gap-3"}>
                        <p className={"col-span-4"}>Acionado em <span className={"info"}>{event.dtStart}</span></p>
                        <p className={"col-span-2"}>Assumido por <span className={"info"}>{event.userAck}</span> em <span className={"info"}>{event.dtAck}</span></p>
                        <p className={"col-span-2"}>Finalizado por <span className={"info"}>{event.userEnd}</span> em <span className={"info"}>{event.dtEnd}</span></p>
                        <p className={"col-span-4"}>Providência: <span className={"info"}>{event.providence}</span></p>
                        <p className={"col-span-4"}>Observação: <span className={"info"}>{event.observation}</span></p>
                    </section>
                </article>

                <article className={"space-y-4"}>
                    <h2 className={"resume-title"}>
                        Dados do protegido
                    </h2>

                    <section className={"grid grid-cols-2 gap-3"}>
                        <p>Nome: <span className={"info"}>{citizen?.name}</span></p>
                        <p>Telefone: <span className={"info"}>{projectUtils.formatPhone(citizen?.phone)}</span></p>
                        <p>Última localização: <span className={"info"}>{(location?.dtLocation || location?.dtLocal) ?? "Não foi possível obter a localização"}</span></p>
                        <p className={"col-span-2"}>Programas de proteção: <span className={"info"}>{citizen?.protectionPrograms?.map(p => p.name).join(", ")}</span></p>
                    </section>
                </article>

                {
                    citizen?.aggressors?.map((aggressor, i) => (
                        <article id={"aggressor-" + i} className={"space-y-3"} key={"aggressor-" + aggressor.itemId}>
                            <h2 className={"resume-title"}>
                                Agressor {i + 1}
                            </h2>

                            <section className={"grid grid-cols-2 gap-3"}>
                                <p>Nome: <span className={"info"}>{aggressor.name}</span></p>
                                <p>Histórico de uso de arma de fogo: <span className={"info"}>{aggressor.firearmUseHistory ? "Sim" : "Não"}</span></p>
                                <p>Tipo de medida: <span className={"info"}>{ProtectionTypes.toView(aggressor.protectionType)}</span></p>
                                <p>Tipo de violência: <span className={"info"}>{ViolenceType.toView(aggressor.violenceTypes)}</span></p>
                            </section>
                        </article>
                    ))
                }

                {
                    !!citizen.addresses?.length &&
                    <article id={"addresses"} className={"space-y-3"}>
                        <h2 className={"resume-title"}>
                            Endereços
                        </h2>

                        {
                            citizen?.addresses?.map((a, i) => (
                                <section  key={a.id}>
                                    <p>Identificação: <span className={"info"}>{a.description}</span></p>
                                    <p>Endereço: <span className={"info"}>{prepareAddress(a)}</span></p>
                                </section>
                            ))
                        }
                    </article>
                }

                <article className={"space-y-3 break-before-page"}>
                    <h2 className={"resume-title"}>
                        Mapa
                    </h2>

                    <div id="mapSnapshot"></div>

                    <span className={"flex gap-2 items-center italic"}>
                        <span className={["w-6 h-6 rounded-[50%] inline-flex justify-center items-center", target === "citizen" ? "bg-[#ff2121]" : "bg-[var(--blue-dark)]"].join(" ")}>
                            <FaUser color={"#ffffff"}/>
                        </span>

                        Última localização

                        {
                            showRoute &&
                            <>
                                {/*<span className={["w-6 h-6 rounded-[50%] inline-flex justify-center items-center", target === "citizen" ? "bg-[#ff2121]" : "bg-(--blue-dark)"].join(" ")} />*/}
                                <img className={"w-6 h-6"} src={getAssetPath(target === "citizen" ? "img/sos/map-markers/pin-person-location-red.svg" : "img/sos/map-markers/pin-person-location.svg")} alt=""/>
                                Localização do acionamento
                            </>
                        }
                    </span>
                </article>

                {
                    !isApi && chat?.status === "SUCCESS" && !!chat?.chat?.result?.updated?.length &&
                    <article className={"space-y-4 break-before-page"}>
                        <h2 className={"resume-title"}>
                            Histórico do chat
                        </h2>

                        <ul className={"chat-body w-1/2 place-self-center rounded-md"}>
                            {
                                chat.chat.result.updated.map((message) => (
                                    <ChatMessage
                                        key={message._id}
                                        message={message}
                                        history={true}
                                    />
                                ))
                            }
                        </ul>
                    </article>
                }
            </div>
        </PrintTemplate>
    );
};

export default SosPrint;